import React, { useState } from "react";
import { PlayCircle, Bell } from "lucide-react";
import { IMAGES } from "../mock";
import { createSignup } from "../api";
import { SectionLabel } from "../components/Bits";

const UPCOMING = [
  { title: "The Beltline in a Day", note: "A full episode filmed across Calgary's busiest food corridor.", img: IMAGES.moody1 },
  { title: "Inside a Placeworthy Review", note: "How an anonymous visit actually works, start to finish.", img: IMAGES.chef1 },
  { title: "Alberta's Best Sourdough", note: "A short-form series on the bakers redefining the prairies.", img: IMAGES.dish4 },
];

export default function Videos() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await createSignup(email, "videos");
    } catch (_) {
      try {
        const list = JSON.parse(localStorage.getItem("pw_video_subs") || "[]");
        list.push({ email, at: new Date().toISOString() });
        localStorage.setItem("pw_video_subs", JSON.stringify(list));
      } catch (_) {}
    }
    setDone(true);
    setEmail("");
  };

  return (
    <div className="pt-[68px]">
      {/* Hero */}
      <section className="relative min-h-[70vh] flex items-center overflow-hidden bg-ink">
        <div className="absolute inset-0 opacity-40 kenburns">
          <img src={IMAGES.chef2} alt="Filming" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/50" />
        <div className="absolute inset-0 grain" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 w-full text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-8 bg-brass" />
            <span className="eyebrow text-brass">Videos</span>
            <span className="h-px w-8 bg-brass" />
          </div>
          <PlayCircle className="w-16 h-16 text-paper/80 mx-auto mb-8" strokeWidth={1} />
          <h1 className="font-serif text-paper text-4xl sm:text-5xl md:text-7xl font-semibold leading-[1.02] display-balance max-w-3xl mx-auto">
            Episodes are coming soon.
          </h1>
          <p className="text-paper/70 mt-6 text-lg max-w-xl mx-auto leading-relaxed">
            We are building a channel of YouTube episodes and short-form films — the same honest reviews,
            told on camera. Real content lands here the moment it goes live.
          </p>

          {done ? (
            <p className="mt-10 text-brass font-medium">You are on the list. We'll send the first episode your way.</p>
          ) : (
            <form onSubmit={submit} className="mt-10 flex max-w-md mx-auto border-b border-paper/30 focus-within:border-brass transition-colors">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Get notified when episodes drop"
                className="flex-1 bg-transparent py-3 text-paper placeholder-paper/40 outline-none"
              />
              <button className="flex items-center gap-1.5 text-sm font-semibold text-brass hover:gap-2.5 transition-all">
                <Bell className="w-4 h-4" /> Notify me
              </button>
            </form>
          )}
        </div>
      </section>

      {/* Upcoming */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <SectionLabel>In production</SectionLabel>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-semibold mt-4 mb-12 display-balance">
          A first look at what's filming.
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {UPCOMING.map((v, i) => (
            <div key={i} className="group rise-in" style={{ animationDelay: `${i * 80}ms` }}>
              <div className="relative aspect-video bg-ink/5 overflow-hidden">
                <img src={v.img} alt={v.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" loading="lazy" />
                <div className="absolute inset-0 bg-ink/30 flex items-center justify-center">
                  <PlayCircle className="w-14 h-14 text-paper/90" strokeWidth={1} />
                </div>
                <span className="absolute top-4 left-4 eyebrow text-paper text-[10px] bg-ink/60 px-3 py-1.5">Coming soon</span>
              </div>
              <h3 className="font-serif text-2xl font-semibold mt-4">{v.title}</h3>
              <p className="text-sm text-ink-soft mt-2 leading-relaxed">{v.note}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
